//@flow
import * as React from 'react';
import Checkbox from 'common/components/core/checkbox/';
import { SelectTypes, Select } from 'common/components/core/select/Select';
import { UIFilter } from 'common/models/internal/UIFilter';
import classnames from 'classnames';
import { SizeEnum } from 'common/enums/UIEnums';

type Props = {
    className?: string,
    filter: UIFilter,
    theme: Object,
    appliedFilter: {
        isFilterApplied: boolean,
        value: Array<string> | boolean,
        idList: ?Array<string>
    },
    onChange: ({
        value: Array<any> | boolean,
        id: string,
        idList: Array<string>
    }) => void
};
export const FilterElementsEnum = {
    Checkbox: 'checkbox'
};
class Filter extends React.PureComponent<Props> {
    onChange = value => {
        const { onChange, filter } = this.props;
        const { id } = filter;
        onChange({ value, id });
    };
    onMultiChange = value => {
        const newValue = value.map(value => value.value);
        this.onChange(newValue);
    };

    render() {
        const {
            filter,
            appliedFilter,
            className,
            theme,
            ...others
        } = this.props;
        const { value } = appliedFilter || {};
        const { element, options, label } = filter;
        if (element === FilterElementsEnum.Checkbox) {
            return (
                <Checkbox
                    {...others}
                    smallCheckbox
                    theme={theme}
                    className={classnames(
                        { [theme.filter]: !!theme.filter },
                        className
                    )}
                    checked={value}
                    label={label}
                    onChange={this.onChange}
                />
            );
        }
        return (
            <Select
                {...others}
                theme={theme}
                selectSize={SizeEnum.Medium}
                selectLabel={label}
                isMulti
                className={classnames(
                    { [theme.filter]: !!theme.filter },
                    className
                )}
                options={options}
                value={value}
                onChange={this.onMultiChange}
                selectType={SelectTypes.Outline}
            />
        );
    }
}

export { Filter };
export default Filter;
